/**
 * Created by hyr on 19/1/30.
 * 活动各种名称配置文件, 需要用户手动配置
 */
export default {
  name: 'P00760', // 埋点名称
  aosName: 'car-promotion', // aos链接名称
  activity: 'car-promotion', // aos通用模块活动名称
};
